<template lang="pug">
  div
    div.conteiner
      el-tabs.content(:value="menu" @tab-click="mudarTab")
        template(v-for="tab in tabs")
          el-tab-pane(:name="tab.name")
            span(slot="label")
              | {{tab.label}} &nbsp
      app-opcoes-header-analise(
        :idProcesso="processo.id",
        :protocolo="processo.numeroProtocolo"
        :statusProcesso="processo.status"
        :numeroProcesso="processo.numeroProcesso",
        :btnRetificacao="true",
        :btnPendencia= "true",
        :tipoProcesso="processo.tipo.codigo"
      ).right
    div.container-tab
      router-view(
        :oficios="[oficio]"
        :processo="processo"
        :despacho="despacho"
        @atualizarOficio="atualizarOficio",
        :isEdicao="isEdicao",
        v-if="loaded"
      )
</template>

<script>
import acaoProcesso from '@/constants/acaoProcesso'
import { mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import AppOpcoesHeaderAnalise from '../components/modal/AppOpcoesHeaderAnalise.vue'

const OFICIO_CCR_EMPTY = {
  numeroOficio: '',
  dataEmissao: new Date(),
  nomeCartorio: '',
  nomeTabeliao: '',
  municipio: '',
  uf: 'Maranhão',
  bairro: '',
  cep: '',
  rua: '',
  numero: '',
  complemento: '',
  numeroProcesso: '',
  nomeRazaoSocialInteressado: '',
  cpfCnpjInteressado: '',
  semNumero: false,
  denominacaoImovel: '',
  nomeDaGleba: '',
  areaImovel: 0,
  municipioImovel: '',
  tituloDominial: '',
  numeroMatricula: '',
  folhaMatricula: '',
  livroMatricula: '',
  dataRegistro: new Date()
}

const DESPACHO_EMPTY = {
  tituloDespacho: {
    oficioCcrDTO: {
      textoOficio: ''
    }
  },
  tipo: 'OFICIO_CCR',
  processo: {}
}

export default {
  components: {
    AppOpcoesHeaderAnalise
  },
  props: {
    isEdicao: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      processo: {},
      oficio: cloneDeep(OFICIO_CCR_EMPTY),
      despacho: cloneDeep(DESPACHO_EMPTY),
      idProcesso: null,
      tipo: acaoProcesso.EMITIR_TITULO,
      loaded: false
    }
  },

  async created () {
    const { idProcesso } = this.$route.query
    this.idProcesso = idProcesso

    try {
      if (idProcesso) {
        await this.findByIdProcesso(idProcesso).then(response => {
          this.processo = response
          this.despacho.processo = this.processo
        })
        if (!this.isEdicao) {
          const numeroOficio = await this.getNumeroOficio()
          this.oficio.numeroOficio = 'N°' + numeroOficio + ' ITERMA/DRF/SICARF'
          this.despacho.oficio = this.oficio
          const dadosCadastro = await this.dadosImovel(idProcesso)
          this.despacho.oficio = {
            ...this.despacho.oficio,
            ...dadosCadastro,
            nomeRazaoSocialInteressado: this.processo.nomeRazaoSocialInteressado
          }
          this.despacho.tituloDespacho.oficioCcrDTO = {
            ...this.despacho.oficio
          }
          const despacho = await this.criarNovoOficio(this.despacho)
          this.despacho.id = despacho.id
          this.isEdicao = true
        } else {
          const despacho = await this.getDespachoOficioCcr(idProcesso)
          this.despacho = despacho
          this.despacho.processo = this.processo
          this.despacho.oficio = JSON.parse(despacho.tituloDespacho.tituloProcesso)
          this.oficio = JSON.parse(despacho.tituloDespacho.tituloProcesso)
        }
      } else {
        this.goToListagem()
      }
    } catch (error) {
      this.goToListagem()
    }
    this.despacho.tituloDespacho.oficioCcrDTO = this.despacho.oficio
    if (!this.isEdicao) {
      await this.editarOficio(this.despacho)
    }
    this.loaded = true
  },

  computed: {
    indexTabAtual () {
      return this.tabs.findIndex(tab => tab.name === this.$route.name)
    },

    tabs () {
      const acoes = []

      acoes.push({
        label: 'Emissão do ofício',
        name: 'oficio/emissaoDRF',
        dadosRequest: {
          url: '',
          dados: this.oficios,
          despacho: this.despacho
        }
      })

      return acoes
    },

    menu () {
      return this.$route.name
    },

    isPrimeiroPasso () {
      return this.indexTabAtual === 0
    },

    isUltimoPasso () {
      return this.indexTabAtual === this.tabs.length - 1
    }
  },

  methods: {
    ...mapActions({
      findByIdProcesso: 'processo/getProcessoById',
      getDespachoOficioCcr: 'despacho/getDespachoOficioCcr',
      criarNovoOficio: 'despacho/criarNovoOficioCcr',
      getNumeroOficio: 'despacho/getNumeroOficio',
      editarOficio: 'despacho/editarTituloCertidao',
      dadosImovel: 'despacho/dadosImovel'
    }),

    goToListagem () {
      this.$router.push({
        name: 'cpat/home'
      })
    },

    atualizarOficio (oficio) {
      this.oficio = oficio
    },

    mudarTab (componente) {
      const indexTab = this.tabs.findIndex(
        tab => tab.name === componente._props.name
      )
      this.navigate(indexTab)
    },

    async navigate (indexTab) {
      const query = {}
      query.idProcesso = this.processo.id

      try {
        this.$router.push({
          name: this.tabs[indexTab].name,
          query
        })
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size-small: 12px;

.content {
  flex: 1;
  padding-top: 10px;
  width: 50%;
}

.container-tab {
  padding: 10px;
}

pre {
  font-size: $font-size-small;
}
.conteiner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
}
.right {
  width: 50%;
  display: flex;
  justify-content: end;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/oficio/Oficio.vue